import React, { useCallback, useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { Dropdown, Menu, notification, Spin, Tooltip } from "antd";
import { ArrowLeftOutlined, DownOutlined } from "@ant-design/icons";
import { useSelector } from "react-redux";
import { useIntl } from "react-intl";
import { useHistory } from "react-router-dom";
import {
  BackButton,
  BackIcon,
  BackSpan,
  StyledInput,
  NavegationAndInfosContainer,
  EventBadge,
  ClienteBadge,
  Title,
  SubTitle,
  Container,
  StyledSpan,
} from "../style";
import {
  TableWrapper,
  CustomTable,
  ProductsAndServicesCustomTable,
  StyledTabs,
  ButtonFormConfirm,
  DropdownButton,
  ProductServiceTableWrapper,
  OrderStatusBadge,
} from "./styles";
import api from "../../../../service";
import { format } from "date-fns";
import { Strings } from "../../../../utils/stringSanitize";
import opportunityStatusTypesConstants from "../../../../constants/opportunityStatusTypes";
import clientTypesConstants from "../../../../constants/clientTypes";
import { formatCNPJ, stripCNPJ } from "../../../../utils/cnpjManager";
import { NoData } from "../../SelectEvent/styles";
import { AttentionIcon } from "../Sales/components/Icons";
import { Nav } from "../Sales/styles";
import GoBackButton from "../../components/goBackButton";
import { FantasyNameAndContractBadge } from "../../components/badges";

const StaffServiceContract = () => {
  const intl = useIntl();
  const { token } = useSelector((state) => state.auth);
  const history = useHistory();
  const location = useLocation();
  const [activeTab, setActiveTab] = useState("1");
  const [contract, setContract] = useState([]);
  const fantasyName = localStorage.getItem("serviceFantasyname");
  const serviceContractNumber = localStorage.getItem("serviceContractNumber");
  const opportunityStatusTypes = opportunityStatusTypesConstants();
  const clientTypes = clientTypesConstants();
  const [inputValue, setInputValue] = useState(undefined);
  const [selectedBoothIndex, setSelectedBoothIndex] = useState(null);
  const [loading, setLoading] = useState(true);
  const [pageSize, setPageSize] = useState(5);
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize2, setPageSize2] = useState(5);
  const [currentPage2, setCurrentPage2] = useState(1);
  const [optionalProducts, setOptionalProducts] = useState([]);
  const serviceOpportunityNumber = localStorage.getItem(
    "serviceOpportunityNumber",
  );
  const serviceSystemUserId = localStorage.getItem("serviceSystemUserId");
  const serviceProvider = contract?.serviceProvider;
  const isServiceProvider = Boolean(serviceProvider);
  const serviceOpportunityId = localStorage.getItem("serviceOpportunityId");
  const serviceEventId = localStorage.getItem("serviceEventId");

  const [serviceProviders, setServiceProviders] = useState([]);
  const [providersPagination, setProvidersPagination] = useState(null);
  const [providersPage, setProvidersPage] = useState(1);
  const [providersPageSize, setProvidersPageSize] = useState(10);
  const [providersSortBy, setProvidersSortBy] = useState(undefined);
  const [providersSortDirection, setProvidersSortDirection] =
    useState(undefined);
  const [providersLoading, setProvidersLoading] = useState(false);
  const [providersLoaded, setProvidersLoaded] = useState(false);
  const [providersError, setProvidersError] = useState(false);

  useEffect(() => {
    fetchOptionalProducts();
    fetchData();
  }, []);

  useEffect(() => {
    if (contract.booths?.length === 1) {
      setSelectedBoothIndex(0);
    } else {
      setSelectedBoothIndex(null);
    }
  }, [contract.booths]);

  const fetchData = useCallback(async () => {
    setLoading(true);
    try {
      const result = await api.get(
        `/admin/opportunity/${serviceOpportunityNumber}${
          serviceSystemUserId ? `?userId=${serviceSystemUserId}` : ""
        }`,
        {
          headers: {
            "Content-Type": "application/json",
            Accept: "*/*",
            Authorization: `Bearer ${token}`,
          },
        },
      );

      setContract(result.data.opportunity);
    } catch (error) {
      notification.error({
        message: intl.formatMessage({
          id: "error",
        }),
        description: intl.formatMessage({
          id: "api.error." + error.response?.data?.description,
        }),
      });
    } finally {
      setLoading(false);
    }
  }, []);

  const fetchOptionalProducts = useCallback(async () => {
    setLoading(true);
    try {
      const result = await api.patch(
        `ecommerce/chleba/order`,
        {
          contractNumber: serviceContractNumber,
          userId: serviceSystemUserId,
        },
        {
          headers: {
            "Content-Type": "application/json",
            Accept: "*/*",
            Authorization: `Bearer ${token}`,
          },
        },
      );
      const items = result.data.ecommerceChlebaOrderFilterOutput.flatMap(
        (order) =>
          order.chlebaItemOutputs.map((item) => ({
            description: item.description,
            type: item.type,
            quantity: item.quantity,
            unitValue: item.unitValue,
            orderId: order.orderId,
            status: order.statusDesc,
          })),
      );

      setOptionalProducts(items);
    } catch (error) {
      notification.error({
        message: intl.formatMessage({
          id: "error",
        }),
        description: intl.formatMessage({
          id: "api.error." + error.response?.data?.description,
        }),
      });
    } finally {
      setLoading(false);
    }
  }, []);

  const fetchServiceProviders = useCallback(async () => {
    setProvidersLoading(true);
    setProvidersError(false);
    try {
      const result = await api.get(`/provider-association`, {
        headers: {
          "Content-Type": "application/json",
          Accept: "*/*",
          Authorization: `Bearer ${token}`,
        },
        params: {
          page: providersPage - 1,
          per_page: providersPageSize,
          event_id: serviceEventId,
          opportunity_id: serviceOpportunityId,
          search: "",
          sortBy: providersSortBy,
          sortDirection: providersSortDirection,
        },
      });
      setServiceProviders(result.data.output || []);
      setProvidersPagination(result.data.paginationInfo);
    } catch (error) {
      // Falha de servico e distinta de "sem registros": limpa a tabela e sinaliza erro.
      setProvidersError(true);
      setServiceProviders([]);
      setProvidersPagination(null);
      notification.error({
        message: intl.formatMessage({ id: "error" }),
        description: intl.formatMessage({
          id: "api.error." + error.response?.data?.description,
        }),
      });
    } finally {
      setProvidersLoading(false);
      setProvidersLoaded(true);
    }
  }, [
    providersPage,
    providersPageSize,
    providersSortBy,
    providersSortDirection,
    serviceEventId,
    serviceOpportunityId,
    token,
    intl,
  ]);

  useEffect(() => {
    if (activeTab === "7") {
      fetchServiceProviders();
    }
  }, [activeTab, fetchServiceProviders]);

  const handleServiceProvidersTableChange = (pagination, filters, sorter) => {
    setProvidersPage(pagination.current);
    setProvidersPageSize(pagination.pageSize);
    if (sorter && sorter.order) {
      setProvidersSortBy(sorter.columnKey || sorter.field);
      setProvidersSortDirection(sorter.order === "ascend" ? "ASC" : "DESC");
    } else {
      setProvidersSortBy(undefined);
      setProvidersSortDirection(undefined);
    }
  };

  const saveHeadbandOpportunity = useCallback(() => {
    api
      .post(
        `/admin/opportunity/headband`,
        {
          opportunityId: localStorage.getItem("serviceOpportunityNumber"),
          headband: inputValue,
        },
        {
          headers: {
            "Content-Type": "application/json",
            Accept: "*/*",
            Authorization: `Bearer ${token}`,
          },
        },
      )
      .then((result) => {
        notification.success({
          message: intl.formatMessage({ id: "success" }),
          description: intl.formatMessage({
            id: "success.front_sign_opportunity_creation",
          }),
        });
      })
      .catch((err) => {
        notification.error({
          message: intl.formatMessage({ id: "error" }),
          description: intl.formatMessage({
            id: "api.error." + err.response?.data?.code || "default_error",
          }),
        });
      });
  }, [inputValue]);

  const items = [
    { key: "1", label: intl.formatMessage({ id: "general_information" }) },
    { key: "2", label: intl.formatMessage({ id: "client" }) },
    { key: "3", label: intl.formatMessage({ id: "about_event" }) },
    { key: "4", label: intl.formatMessage({ id: "booth" }) },
    { key: "5", label: intl.formatMessage({ id: "observations" }) },
    { key: "6", label: intl.formatMessage({ id: "products_services" }) },
    ...(isServiceProvider
      ? []
      : [{ key: "7", label: intl.formatMessage({ id: "service_providers" }) }]),
    ...(isServiceProvider
      ? [{ key: "8", label: intl.formatMessage({ id: "exhibitor" }) }]
      : []),
  ];

  const exhibitorRows = [
    {
      key: "1",
      col1: intl.formatMessage({ id: "company_name" }),
      col2: contract?.account?.accountName
        ? contract?.account?.accountName
        : "-",
    },
    {
      key: "2",
      col1: intl.formatMessage({ id: "fantasy_name" }),
      col2: contract?.account?.accountAlias
        ? contract?.account?.accountAlias
        : "-",
    },
    {
      key: "3",
      col1: "CNPJ",
      col2: contract?.account?.accountGovCompanyCode
        ? contract?.account?.accountGovCompanyCode
        : "-",
    },
    {
      key: "4",
      col1: intl.formatMessage({ id: "responsible_email" }),
      col2: contract.opportunityContact?.email
        ? contract.opportunityContact?.email
        : "-",
    },
    {
      key: "5",
      col1: intl.formatMessage({ id: "responsible" }),
      col2:
        contract?.operationsContact &&
        Strings.fullname(
          contract?.operationsContact?.firstName,
          contract?.operationsContact?.lastName
        ),
    },
    {
      key: "6",
      col1: intl.formatMessage({ id: "fiscal_email" }),
      col2: contract?.billingContact?.email
        ? contract?.billingContact?.email
        : "-",
    },
    {
      key: "7",
      col1: intl.formatMessage({ id: "responsible_for_the_invoice" }),
      col2:
        contract?.billingContact &&
        Strings.fullname(
          contract?.billingContact?.firstName,
          contract?.billingContact?.lastName
        ),
    },
    {
      key: "8",
      col1: intl.formatMessage({ id: "operational_email" }),
      col2: contract.operationsContact?.email
        ? contract.operationsContact?.email
        : "-",
    },
    {
      key: "9",
      col1: intl.formatMessage({ id: "operational_manager" }),
      col2:
        contract?.operationsContact &&
        Strings.fullname(
          contract?.operationsContact?.firstName,
          contract?.operationsContact?.lastName
        ),
    },
    {
      key: "10",
      col1: intl.formatMessage({ id: "marketing_email" }),
      col2: contract.marketingContact?.email
        ? contract.marketingContact?.email
        : "-",
    },
    {
      key: "11",
      col1: intl.formatMessage({ id: "telephone" }),
      col2: contract.account?.phone ? contract.account?.phone : "-",
    },
  ];

  const serviceProviderRows = [
    {
      key: "1",
      col1: intl.formatMessage({ id: "corporate_name" }),
      col2: serviceProvider?.companyName || "-",
    },
    {
      key: "2",
      col1: intl.formatMessage({ id: "fantasy_name" }),
      col2: serviceProvider?.tradeName || "-",
    },
    {
      key: "3",
      col1: "CNPJ",
      col2: serviceProvider?.document || "-",
    },
    {
      key: "4",
      col1: intl.formatMessage({ id: "state_inscription" }),
      col2: serviceProvider?.stateInscription || "-",
    },
    {
      key: "5",
      col1: intl.formatMessage({ id: "city_inscription" }),
      col2: serviceProvider?.municipalInscription || "-",
    },
    {
      key: "6",
      col1: intl.formatMessage({ id: "email" }),
      col2: serviceProvider?.email || "-",
    },
    {
      key: "7",
      col1: intl.formatMessage({ id: "tax_classification" }),
      col2: serviceProvider?.taxClassification || "-",
    },
    {
      key: "8",
      col1: intl.formatMessage({ id: "telephone" }),
      col2: serviceProvider?.telephone || "-",
    },
    {
      key: "9",
      col1: intl.formatMessage({ id: "mobile" }),
      col2: serviceProvider?.mobile || "-",
    },
    {
      key: "10",
      col1: intl.formatMessage({ id: "service_type" }),
      col2: serviceProvider?.providedServices?.join(", ") || "-",
    },
  ];

  const serviceProviderColumns = [
    {
      title: "CNPJ",
      dataIndex: "document",
      key: "document",
      sorter: true,
      width: "25%",
    },
    {
      title: intl.formatMessage({ id: "corporate_name" }),
      dataIndex: "serviceProviderCorporateName",
      key: "corporateName",
      sorter: true,
      width: "25%",
    },
    {
      title: intl.formatMessage({ id: "fantasy_name" }),
      dataIndex: "serviceProviderName",
      key: "companyName",
      sorter: true,
      width: "25%",
    },
    {
      title: intl.formatMessage({ id: "service_type" }),
      dataIndex: "serviceTypeName",
      key: "serviceType",
      sorter: true,
      width: "25%",
    },
  ];

  console.log(serviceProviders);

  const serviceProvidersData = serviceProviders.map((sp, index) => ({
    key: sp.id ?? `sp-${index}`,
    document:
      stripCNPJ(sp.document).length === 14
        ? formatCNPJ(sp.document)
        : sp.document || "-",
    serviceProviderCorporateName: sp.serviceProviderCorporateName || "-",
    serviceProviderName: sp.serviceProviderName || "-",
    serviceTypeName: sp.serviceTypeName || "-",
  }));

  const tablesData = {
    1: [
      {
        key: "1",
        col1: intl.formatMessage({ id: "contract_number" }),
        col2: contract.contractNumber,
      },
      {
        key: "2",
        col1: intl.formatMessage({ id: "creation" }),
        col2: contract.createdAt
          ? format(new Date(contract.createdAt), "dd/MM/yyyy")
          : "-",
      },
      {
        key: "3",
        col1: intl.formatMessage({ id: "update" }),
        col2: contract.lastModifiedDate
          ? format(new Date(contract.lastModifiedDate), "dd/MM/yyyy")
          : "-",
      },
      {
        key: "4",
        col1: intl.formatMessage({ id: "client_type" }),
        col2: clientTypes.filter((pt) => pt.value === contract?.contractType)[0]
          ?.label,
      },
      {
        key: "5",
        col1: intl.formatMessage({ id: "user_type" }),
        col2: contract.actorType
          ? intl.formatMessage({ id: contract.actorType })
          : "-",
      },
      {
        key: "6",
        col1: intl.formatMessage({ id: "parent_opportunity" }),
        col2: contract.parentOpportunity
          ? intl.formatMessage({ id: contract.parentOpportunity })
          : "-",
      },
      {
        key: "7",
        col1: intl.formatMessage({ id: "contract_type" }),
        col2: contract.type ? contract.type : "-",
      },
      {
        key: "8",
        col1: intl.formatMessage({ id: "currency" }),
        col2: contract.contractCurrency ? contract.contractCurrency : "-",
      },
      {
        key: "9",
        col1: intl.formatMessage({ id: "contract_value" }),
        col2: contract.amount ? contract.amount : "-",
      },
      {
        key: "10",
        col1: intl.formatMessage({ id: "special_conditions" }),
        col2: contract.specialConditions ? contract.specialConditions : "-",
      },
      {
        key: "11",
        col1: intl.formatMessage({ id: "paid_by" }),
        col2: contract.paidBy ? contract.paidBy : "-",
      },
      {
        key: "12",
        col1: (
          <>
            {intl.formatMessage({ id: "default_vip_quantity" })}
            <br />
            <span
              style={{
                color: "rgba(98, 116, 142, 1)",
                fontSize: "16px",
                fontWeight: "400",
                fontFamily: "Inter",
              }}
            >
              {`${"("}${intl.formatMessage({ id: "event_edition" })}${")"}`}
            </span>
          </>
        ),

        col2: contract.eventVipMetric ? contract.eventVipMetric : "-",
      },
      {
        key: "13",
        col1: intl.formatMessage({ id: "opportunity_status" }),
        col2: opportunityStatusTypes.filter(
          (pt) => pt.value === contract?.status
        )[0]?.label,
      },
    ],

    2: isServiceProvider ? serviceProviderRows : exhibitorRows,
    3: [
      {
        key: "1",
        col1: intl.formatMessage({ id: "edition" }),
        col2: contract.eventEditionName ? contract.eventEditionName : "-",
      },
      {
        key: "2",
        col1: intl.formatMessage({ id: "prefix" }),
        col2: contract.eventEditionCode ? contract.eventEditionCode : "-",
      },
      {
        key: "3",
        col1: intl.formatMessage({ id: "year" }),
        col2: contract.eventStartDate ? contract.eventStartDate : "-",
      },
      {
        key: "4",
        col1: intl.formatMessage({ id: "pavilion" }),
        col2: contract.booths?.pavilion ? contract.booths?.pavilion : "-",
      },
      {
        key: "5",
        col1: intl.formatMessage({ id: "address" }),
        col2: contract.eventVenue ? contract.eventVenue : "-",
      },
    ],
    4: contract.booths?.[selectedBoothIndex]
      ? [
          {
            key: "1",
            col1: intl.formatMessage({ id: "booth_number" }),
            col2: contract.booths[selectedBoothIndex].boothNumber ?? "-",
          },
          {
            key: "2",
            col1: intl.formatMessage({ id: "area_" }),
            col2: contract.booths[selectedBoothIndex].area ?? "-",
          },
          {
            key: "3",
            col1: intl.formatMessage({ id: "booth_type_" }),
            col2: contract.booths[selectedBoothIndex].type ?? "-",
          },
        ]
      : [],
    5: [
      {
        key: "1",
        col1: intl.formatMessage({ id: "observations" }),
        col2: contract.observation ? contract.observation : "-",
      },
    ],
    8: exhibitorRows,
  };

  // Produtos obrigatorios/extras do contrato (sem pedido de e-commerce
  // associado) nao tem orderId/status; exibimos como confirmados sem numero
  // de pedido, espelhando ProductAcquiredDetailsDTO#isConfirmedOrder no backend.
  const getOrderNumber = (item) => item?.orderId ?? "-";

  // Deve bater com ChlebaService.CONFIRMED_PAYMENT_STATUS no backend.
  const CONFIRMED_PAYMENT_STATUS = "Pagamento Confirmado";

  const getOrderStatusConfig = (item) => {
    const statusConfig = {
      confirmed: { id: "order_confirmed", variant: "confirmed" },
      canceled: { id: "order_canceled", variant: "canceled" },
      pending: { id: "order_pending", variant: "pending" },
    };

    // Produtos obrigatorios/extras do contrato nao tem status (nunca passaram
    // por um pedido de e-commerce) e sao sempre confirmados.
    if (item?.status == null) {
      return statusConfig.confirmed;
    }

    if (item.status.toLowerCase() === CONFIRMED_PAYMENT_STATUS.toLowerCase()) {
      return statusConfig.confirmed;
    }

    // O Chleba cancela reaproveitando o ConfirmaPedido com status=2; o texto
    // exato retornado em "statusDesc" para esse caso ainda nao foi confirmado
    // em teste, entao usamos uma checagem tolerante por "cancel" em vez de
    // comparacao exata.
    if (item.status.toLowerCase().includes("cancel")) {
      return statusConfig.canceled;
    }

    return statusConfig.pending;
  };

  const getOrderStatusBadge = (item) => {
    const { id, variant } = getOrderStatusConfig(item);
    return (
      <OrderStatusBadge variant={variant}>
        {intl.formatMessage({ id })}
      </OrderStatusBadge>
    );
  };

  const mandatoryProductsData = [
    ...(contract?.mandatoryProducts || []).map((item, index) => ({
      key: `m-${index + 1}`,
      col1:
        item.productLocalName && item.productLocalName.length > 40
          ? item.productLocalName.slice(0, 40) + "..."
          : item.productLocalName || "",
      col2:
        item.description && item.description.length > 40 ? (
          <Tooltip title={item.description}>
            {item.description.slice(0, 40) + "..."}
          </Tooltip>
        ) : (
          item.description || ""
        ),
      col3: item.eventProductType,
      col4: item.quantity,
      col5: new Intl.NumberFormat("pt-BR", {
        style: "currency",
        currency: "BRL",
      }).format(item.totalPrice),
      col6: getOrderNumber(item),
      col7: getOrderStatusBadge(item),
      relatedProducts: item.relatedProducts,
    })),
  ];

  const optionalProductsData = [
    ...(optionalProducts || []).map((item, index) => ({
      key: `o-${index + 1}`,
      col1: item.description,
      col2: item.type,
      col3: item.quantity,
      col4: new Intl.NumberFormat("pt-BR", {
        style: "currency",
        currency: "BRL",
      }).format(item.unitValue),
      col5: getOrderNumber(item),
      col6: getOrderStatusBadge(item),
    })),
  ];

  const columns = [
    {
      title: "",
      dataIndex: "col1",
      key: "col1",
      width: "50%",
    },
    {
      title: "",
      dataIndex: "col2",
      key: "col2",
      width: "50%",
    },
  ];

  const ProductsAndServicesColumns = [
    {
      title: intl.formatMessage({ id: "product" }),
      dataIndex: "col1",
      key: "col1",
      width: "22%",
    },
    {
      title: intl.formatMessage({ id: "description" }),
      dataIndex: "col2",
      key: "col2",
      width: "22%",
    },
    {
      title: intl.formatMessage({ id: "type" }),
      dataIndex: "col3",
      key: "col3",
      width: "12%",
    },
    {
      title: intl.formatMessage({ id: "quantity" }),
      dataIndex: "col4",
      key: "col4",
      width: "10%",
    },
    {
      title: intl.formatMessage({ id: "total_value" }),
      dataIndex: "col5",
      key: "col5",
      width: "12%",
    },
    {
      title: intl.formatMessage({ id: "order_number" }),
      dataIndex: "col6",
      key: "col6",
      width: "12%",
    },
    {
      title: intl.formatMessage({ id: "status" }),
      dataIndex: "col7",
      key: "col7",
      width: "10%",
    },
  ];

  const ProductsOptionalAndServicesColumns = [
    {
      title: intl.formatMessage({ id: "product" }),
      dataIndex: "col1",
      key: "col1",
      width: "28%",
    },
    {
      title: intl.formatMessage({ id: "type" }),
      dataIndex: "col2",
      key: "col2",
      width: "16%",
    },
    {
      title: intl.formatMessage({ id: "quantity" }),
      dataIndex: "col3",
      key: "col3",
      width: "14%",
    },
    {
      title: intl.formatMessage({ id: "total_value" }),
      dataIndex: "col4",
      key: "col4",
      width: "16%",
    },
    {
      title: intl.formatMessage({ id: "order_number" }),
      dataIndex: "col5",
      key: "col5",
      width: "14%",
    },
    {
      title: intl.formatMessage({ id: "status" }),
      dataIndex: "col6",
      key: "col6",
      width: "12%",
    },
  ];

  const expandedRowRender = (record) => {
    if (
      !Array.isArray(record.relatedProducts) ||
      record.relatedProducts.length === 0
    ) {
      return null;
    }

    const rowExpandableChild = (record) =>
      Array.isArray(record.relatedProducts) &&
      record.relatedProducts.length > 0;

    const expandedProductsData = [
      ...(record.relatedProducts || []).map((item, index) => ({
        key: `m-${index + 1}`,
        col1:
          item.productLocalName && item.productLocalName.length > 40
            ? item.productLocalName.slice(0, 40) + "..."
            : item.productLocalName || "",
        col2:
          item.description && item.description.length > 40 ? (
            <Tooltip title={item.description}>
              {item.description.slice(0, 40) + "..."}
            </Tooltip>
          ) : (
            item.description || ""
          ),
        col3: item.eventProductType,
        col4: item.quantity,
        col5: new Intl.NumberFormat("pt-BR", {
          style: "currency",
          currency: "BRL",
        }).format(item.totalPrice),
        relatedProducts: item.relatedProducts,
      })),
    ];

    return (
      <ProductsAndServicesCustomTable
        dataSource={expandedProductsData}
        columns={ProductsAndServicesColumns}
        scroll={{ x: 980 }}
        expandable={{
          expandedRowRender: (record) => expandedRowRender(record),
          rowExpandable: (record) => rowExpandableChild(record),
          defaultExpandAllRows: true,
        }}
        pagination={false}
      />
    );
  };

  const rowExpandable = (record) =>
    Array.isArray(record.relatedProducts) && record.relatedProducts.length > 0;

  const handleGoBack = () => {
    history.push("/staff-access/service-panel");
  };
  useEffect(() => {
    const handleKeyDown = (event) => {
      if (event.key === "Escape") {
        handleGoBack();
      }
    };

    window.addEventListener("keydown", handleKeyDown);
    return () => {
      window.removeEventListener("keydown", handleKeyDown);
    };
  }, []);

  const estandeMenu = (
    <Menu onClick={({ key }) => setSelectedBoothIndex(Number(key))}>
      {(contract.booths || []).map((booth, index) => (
        <Menu.Item key={index}>
          {booth.boothNumber
            ? booth.boothNumber
            : intl.formatMessage({ id: "not_found" })}
        </Menu.Item>
      ))}
    </Menu>
  );

  return (
    <Spin spinning={loading}>
      <Container currentPath={location.pathname}>
        <Nav>
          <GoBackButton
            noPosition
            href={"/staff-access/service-panel"}
            intlId="backToDashboard"
          />

          <FantasyNameAndContractBadge
            fantasyname={fantasyName}
            contractNumber={serviceContractNumber}
          />
        </Nav>
        <Title>{intl.formatMessage({ id: "contract" })}</Title>

        <StyledTabs
          activeKey={activeTab}
          onChange={setActiveTab}
          items={items}
        />
        <TableWrapper>
          {(() => {
            switch (activeTab) {
              case "1":
                return (
                  <CustomTable
                    columns={columns}
                    dataSource={tablesData[activeTab]}
                    pagination={false}
                    showHeader={false}
                  />
                );
              case "2":
                return (
                  <CustomTable
                    columns={columns}
                    dataSource={tablesData[activeTab]}
                    pagination={false}
                    showHeader={false}
                  />
                );
              case "3":
                return (
                  <CustomTable
                    columns={columns}
                    dataSource={tablesData[activeTab]}
                    pagination={false}
                    showHeader={false}
                  />
                );
              case "8":
                return (
                  <CustomTable
                    columns={columns}
                    dataSource={tablesData[activeTab]}
                    pagination={false}
                    showHeader={false}
                  />
                );
              case "4":
                return (
                  <div style={{ marginTop: "15px", width: "700px" }}>
                    <StyledSpan title>
                      {intl.formatMessage({ id: "booth" })}
                    </StyledSpan>
                    <Dropdown overlay={estandeMenu} trigger={["click"]}>
                      <DropdownButton
                        disabled={contract.booths[0].boothId === null}
                        onClick={(e) => e.preventDefault()}
                      >
                        {contract.booths?.[selectedBoothIndex]?.boothNumber
                          ? ` ${contract.booths[selectedBoothIndex].boothNumber}`
                          : intl.formatMessage({ id: "select" })}{" "}
                        <DownOutlined />
                      </DropdownButton>
                    </Dropdown>
                    {selectedBoothIndex !== null &&
                      contract.booths[0]?.boothId !== null && (
                        <div style={{ marginBottom: 24 }}>
                          <CustomTable
                            columns={columns}
                            dataSource={tablesData[activeTab]}
                            pagination={false}
                            showHeader={false}
                          />
                        </div>
                      )}
                    <StyledSpan title>
                      {intl.formatMessage({ id: "front_sign_" })}
                    </StyledSpan>
                    <StyledInput
                      style={{ marginTop: "15px" }}
                      value={inputValue ?? contract?.headband}
                      onChange={(e) => setInputValue(e.target.value)}
                      maxLength="500"
                      placeholder={intl.formatMessage({ id: "front_sign_" })}
                    />
                    <div
                      style={{
                        marginTop: "15px",
                        display: "flex",
                        justifyContent: "flex-end",
                        width: "100%",
                      }}
                    >
                      <ButtonFormConfirm
                        onClick={() => setInputValue("")}
                        style={{ border: "none" }}
                      >
                        {intl.formatMessage({ id: "clear_fields" })}
                      </ButtonFormConfirm>
                      <ButtonFormConfirm
                        type="primary"
                        disabled={!inputValue}
                        onClick={saveHeadbandOpportunity}
                        style={{
                          backgroundColor: "rgba(6, 142, 195, 1)",
                          color: "#fff",
                        }}
                      >
                        {intl.formatMessage({ id: "save_headband" })}
                      </ButtonFormConfirm>
                    </div>
                  </div>
                );
              case "5":
                return (
                  <CustomTable
                    columns={columns}
                    dataSource={tablesData[activeTab]}
                    pagination={false}
                    showHeader={false}
                  />
                );
              case "6":
                return (
                  <ProductServiceTableWrapper>
                    <div>
                      <SubTitle>
                        {intl.formatMessage({ id: "mandatory" })}
                      </SubTitle>
                      <ProductsAndServicesCustomTable
                        columns={ProductsAndServicesColumns}
                        scroll={{ x: 980 }}
                        locale={{ emptyText: <NoDataComponent /> }}
                        dataSource={mandatoryProductsData}
                        pagination={{
                          current: currentPage,
                          pageSize,
                          showSizeChanger: true,
                          total: mandatoryProductsData.length,
                          pageSizeOptions: ["5", "10", "15", "20", "25", "30"],
                          onChange: (page, pageSize) => {
                            setCurrentPage(page);
                            setPageSize(pageSize);
                          },
                          showTotal: (total, range) =>
                            `${intl.formatMessage({ id: "displaying" })} ${
                              range[0]
                            } - ${range[1]} ${intl.formatMessage({
                              id: "of",
                            })} ${total}`,
                          showLessItems: true,
                          locale: { items_per_page: "" },
                          showQuickJumper: false,
                        }}
                        expandable={{
                          expandedRowRender: (record) =>
                            expandedRowRender(record),
                          rowExpandable: (record) => rowExpandable(record),
                          defaultExpandAllRows: true,
                        }}
                        bordered
                      />
                    </div>
                    <div>
                      <SubTitle>
                        {intl.formatMessage({ id: "optional" })}
                      </SubTitle>
                      <ProductsAndServicesCustomTable
                        columns={ProductsOptionalAndServicesColumns}
                        scroll={{ x: 780 }}
                        dataSource={optionalProductsData}
                        locale={{ emptyText: <NoDataComponent /> }}
                        pagination={{
                          current: currentPage2,
                          pageSize: pageSize2,
                          total: optionalProductsData.length,
                          showSizeChanger: true,
                          pageSizeOptions: ["5", "10", "15", "20", "25", "30"],
                          onChange: (page, pageSize) => {
                            setCurrentPage2(page);
                            setPageSize2(pageSize);
                          },
                          showTotal: (total, range) =>
                            `${intl.formatMessage({ id: "displaying" })} ${
                              range[0]
                            }-${range[1]} ${intl.formatMessage({
                              id: "of",
                            })} ${total}`,
                          locale: { items_per_page: "" },
                          showLessItems: true,
                          showQuickJumper: false,
                        }}
                        bordered
                      />
                    </div>
                  </ProductServiceTableWrapper>
                );

              case "7":
                return (
                  <Spin spinning={providersLoading}>
                    {providersError ? (
                      <NoData>
                        <AttentionIcon />
                        <p>
                          {intl.formatMessage({
                            id: "service_provider_load_error",
                          })}
                        </p>
                      </NoData>
                    ) : providersLoaded && serviceProvidersData.length === 0 ? (
                      <NoData>
                        <AttentionIcon />
                        <p>
                          {intl.formatMessage({
                            id: "no_service_provider_associated",
                          })}
                        </p>
                      </NoData>
                    ) : (
                      <ProductsAndServicesCustomTable
                        columns={serviceProviderColumns}
                        dataSource={serviceProvidersData}
                        onChange={handleServiceProvidersTableChange}
                        pagination={{
                          current: providersPage,
                          pageSize: providersPageSize,
                          total: providersPagination?.totalElements ?? 0,
                          showSizeChanger: true,
                          pageSizeOptions: ["5", "10", "15", "20", "25", "30"],
                          showTotal: (total, range) =>
                            `${intl.formatMessage({ id: "displaying" })} ${
                              range[0]
                            } - ${range[1]} ${intl.formatMessage({
                              id: "of",
                            })} ${total}`,
                          showLessItems: true,
                          showQuickJumper: false,
                        }}
                        bordered
                      />
                    )}
                  </Spin>
                );
              default:
                return null;
            }
          })()}
        </TableWrapper>
      </Container>
    </Spin>
  );
};

export default StaffServiceContract;

function NoDataComponent() {
  const intl = useIntl();
  return (
    <NoData>
      <AttentionIcon />
      <p>{intl.formatMessage({ id: "nothing_here_yet" })}</p>
    </NoData>
  );
}
